import "./styles.css";

import React, { useReducer } from "react";

// State Mangement
import { Provider } from "./AppContext";
import AppReducer, { appEvents } from "./reducers";

// Custom components
import Preview from "./Preview";
import Importer, { state as importerState } from "./Importer";
import Exporter from "./Exporter";
import { CircleButton } from "./ui";
import { MdArrowBack, MdFileUpload } from "react-icons/md";
import Card from "./ui/Card";
// import Queue from "./Queue";

// @TODO: Add general compression and selective previews

export const editMode = {
  TILES: "tiles",
  EMAIL_AVATARS: "email_avatars"
};

const initialState = {
  importer: {
    status: importerState.IDLE,
    current: 0,
    total: 0
  },
  mode: null,
  images: []
};

export default function App() {
  const [state, dispatch] = useReducer(AppReducer, initialState);

  const clear = () => {
    dispatch({ type: appEvents.UPDATEIMAGES, payload: [] });
    dispatch({ type: appEvents.UPDATEMODE, payload: null });
  };

  const handleUpdate = ({ data, ...msg }) => {
    dispatch({ type: appEvents.UPDATEIMPORT, payload: msg });
  };

  const { images, importer, mode } = state;

  // No Images loaded
  if (images.length === 0) {
    return (
      <div className="App">
        <Importer
          onStart={handleUpdate}
          onUpdate={handleUpdate}
          onDone={(data) => {
            dispatch({ type: appEvents.UPDATEIMAGES, payload: data });
            dispatch({
              type: appEvents.UPDATEIMPORT,
              payload: {
                status: importerState.IDLE,
                current: 0,
                total: 0
              }
            });
          }}
        >
          <MdFileUpload className="icon" />
          Click or Drag & Drop Image
        </Importer>
      </div>
    );
  }

  if (images.length > 0 && mode === null) {
    return (
      <div className="App">
        <Card>
          <h3>What do you want to edit?</h3>
          <button
            className="primary"
            onClick={() => {
              dispatch({ type: appEvents.UPDATEMODE, payload: editMode.TILES });
            }}
          >
            Class Tiles
          </button>
          <button
            className="primary"
            onClick={() => {
              dispatch({
                type: appEvents.UPDATEMODE,
                payload: editMode.EMAIL_AVATARS
              });
            }}
          >
            Newsletter Avatars
          </button>
        </Card>
      </div>
    );
  }

  return (
    <Provider value={{ state, dispatch }}>
      <div className="App">
        <Exporter />
        <div>
          {importer.status !== importerState.IDLE && (
            <div>
              <h3>State: {importer.status}</h3>
              <h3>
                {importer.current} / {importer.total}
              </h3>
            </div>
          )}
          {images.length !== 0 && (
            <CircleButton
              onClick={clear}
              style={{ position: "fixed", top: "2.4rem", left: "2.4rem" }}
            >
              <MdArrowBack className="icon" />
            </CircleButton>
          )}
          {images.map((image, index) => (
            <Preview key={index} image={image} mode={mode} />
          ))}
        </div>
      </div>
    </Provider>
  );
}
